import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { Link } from "react-router-dom";
import { GetTournamentQuery } from "generated/graphql";
dayjs.extend(isSameOrAfter);

const teamSizeMap = {
  TEAM_SOLO: 1,
  TEAM_DUOS: 2,
  TEAM_TRIOS: 3,
  TEAM_3v3: 3,
  TEAM_SQUAD: 4,
  TEAM_5v5: 5,
};

function TournamentInfo({
  tournamentParticipants,
  calculateDateDifference,
  tournamentData,
  tournamentDetailsMap,
  setModalVisibility,
  loggedInParty,
  isJustRegistered,
}: {
  tournamentParticipants: string[];
  calculateDateDifference: Function;
  tournamentData?: GetTournamentQuery;
  tournamentDetailsMap: any;
  setModalVisibility: Function;
  loggedInParty?: string;
  isJustRegistered: boolean;
}) {
  const isRegistrationWindowOpen = dayjs().isSameOrAfter(
    tournamentDetailsMap["registrationStart"]
  );

  const teamType = tournamentDetailsMap["teamType"];
  // @ts-ignore
  const teamSize = teamSizeMap[teamType];

  let isRegistered = false;
  if (loggedInParty) {
    if (tournamentParticipants.includes(loggedInParty) || isJustRegistered) {
      isRegistered = true;
    }
  }

  return (
    <div id="tournInfo" className="tournament-info-wrapper">
      <div className="tourn_column">
        <div className="tourn_container">
          <h3 style={{ fontSize: "15px" }}>TIMELINE</h3>
          <hr />
          {isRegistrationWindowOpen &&
            calculateDateDifference(
              tournamentDetailsMap["registrationStop"],
              "seconds"
            ) < 0 && (
              <>
                {loggedInParty && isRegistered && (
                  <h4 style={{ textAlign: "center" }}>
                    You are already registered!
                  </h4>
                )}
                {loggedInParty && !isRegistered && (
                  <button
                    onClick={() => setModalVisibility(true)}
                    id="team-btn"
                  >
                    Register for Tournament
                  </button>
                )}
              </>
            )}
          {!loggedInParty &&
            calculateDateDifference(
              tournamentDetailsMap["registrationStop"],
              "seconds"
            ) < 0 && (
              <Link
                style={{ textAlign: "center", display: "block" }}
                to={{
                  pathname: "/auth/login",
                  state: { from: document.location.pathname },
                }}
              >
                Login to register
              </Link>
            )}
          <br />
          {isRegistrationWindowOpen &&
            calculateDateDifference(
              tournamentDetailsMap["registrationStop"],
              "seconds"
            ) < 0 && (
              <p>
                Registration is open and ends: <br />
                {dayjs(
                  tournamentDetailsMap["registrationStop"],
                  "YYYY-MM-DD"
                ).format("ddd	D MMM, YYYY h:mma")}
              </p>
            )}
          {!isRegistrationWindowOpen && (
            <p>
              Registration opens: <br />
              {dayjs(
                tournamentDetailsMap["registrationStart"],
                "YYYY-MM-DD"
              ).format("ddd	D MMM, YYYY h:mma")}
            </p>
          )}
          {isRegistrationWindowOpen &&
            calculateDateDifference(
              tournamentDetailsMap["registrationStop"],
              "seconds"
            ) >= 0 && (
              <p>
                Registration ended: <br />
                {dayjs(
                  tournamentDetailsMap["registrationStop"],
                  "YYYY-MM-DD"
                ).format("ddd	D MMM, YYYY h:mma")}
              </p>
            )}
        </div>
      </div>
      <div className="tourn_info_column">
        <div className="tourn_info_container">
          <h3 style={{ fontSize: "15px" }}>TOURNAMENT DETAILS</h3>
          <hr />
          <h3>Tournament Type</h3>
          <p>{tournamentData?.tournament?.tournamentType.name}</p>
          <h3>Date</h3>
          <p>
            {dayjs(
              // @ts-ignore
              tournamentDetailsMap["tournamentStartTime"],
              "YYYY-MM-DD"
            ).format("ddd	D MMM, YYYY")}
          </p>
          <h3>Time</h3>
          <p>
            {dayjs(
              // @ts-ignore
              tournamentDetailsMap["tournamentStartTime"],
              "YYYY-MM-DDTHH:mm:ss+Z"
            ).format("h:mmA")}
          </p>
          {/* <h3>Prize</h3>
          <p>Ksh 1,000</p> */}
          <h3>Team Size</h3>
          <p>
            {teamType === "TEAM_SQUAD" ? "4v4" : teamType.split("TEAM_")[1]}
          </p>
          <h3>Platform</h3>
          <p>{tournamentDetailsMap["platform"]}</p>
          <h3>Max {teamSize > 1 ? "Teams" : "Participants"}</h3>
          <p>
            {parseInt(tournamentDetailsMap["maximumParticipants"], 10) /
              teamSize}
          </p>
          <h3>Registration Fee</h3>
          <p>{tournamentDetailsMap["registrationFee"]}</p>
        </div>
      </div>
    </div>
  );
}

export default TournamentInfo;
